module.exports = __webpack_public_path__ + "media/images/captive_portal/Home-ae8853826c991893e79e4a405392d4bc.svg";